<div class="container">
  @for (message of conversation?.messages || []; track message; let msgIndex = $index) {
    <div
      class="message message__{{ message.author }}"
    [ngClass]="{
      'message--error': message.type === 'error',
      'message--retry': message.type === 'retry'
    }"
      >
      <!-- Additional content for assistant messages - positioned at top -->
      <!-- Show sources for continued conversations (not first assistant) or when no conversation sources exist -->
      @if (
        message.author === 'assistant' &&
        message.additionalSourceDetails?.length &&
        (!isFirstAssistantMessage(message) || !conversation?.originalSourceDetails?.length)
        ) {
        <div
          class=""
          >
          <app-original-content
            [conversationType]="conversation!.type"
            [content]="message.additionalContent"
            [sources]="message.additionalSourceDetails ?? []"
            [conversationId]="conversation?.id"
            [conversationData]="conversation"
            >
          </app-original-content>
        </div>
      }
      @if (message.author === 'assistant' && hasStreamingThinking(message)) {
        <div class="thinking-state" aria-label="Model reasoning">
          <markdown [data]="message.streamingThinkingText"></markdown>
        </div>
      }
      <div class="conversation-message__answer">
        <app-conversation-paragraphs
          [message]="message"
          (sourceSelected)="openSourcePreviewModal($event, message)"
        ></app-conversation-paragraphs>
      </div>
      <!-- Show typing indicator when text is actively streaming for the last assistant message -->
      @if (message.author === 'assistant' && isWriting && isLastAssistantMessage(message)) {
        <app-typing-indicator
          [isVisible]="true"
          [message]="hasMessageContent(message) ? 'Generating response...' : 'Thinking...'"
        ></app-typing-indicator>
      }
      @if (message.type === 'retry') {
        <app-retry-button
          [disabled]="isBusy || isWriting"
        ></app-retry-button>
      }
      @if (message.referencesToDisplay) {
        <div>
          <app-references
            [references]="message.referencesToDisplay"
            [conversation]="conversation"
            [message]="message"
            (sourceSelected)="openSourcePreviewModal($event, message)"
          ></app-references>
        </div>
      }
      @if (message.paragraphs[message.paragraphs.length - 1]?.quizQuestions) {
        <app-bot-quiz-answers
          [sourcesDetails]="conversation!.originalSourceDetails ?? []"
          [conversation]="conversation!"
          [asResults]="conversation?.type === 'results'"
          [messageIndex]="msgIndex"
          [message]="message"
        ></app-bot-quiz-answers>
      }
      @if (hasMessageContent(message) || message.paragraphs[message.paragraphs.length - 1]?.quizQuestions) {
        <app-message-controls
          [bot]="conversation!.bot!"
          [conversation]="conversation!"
          [hideControls]="shouldHideControls(message)"
          [message]="message"
        ></app-message-controls>
      }
      <!-- Original content for first user message -->
      @if (
        message.author === 'user' &&
        isFirstUserMessage(message) &&
        conversation?.originalSourceDetails?.length
        ) {
        <div
          class="original-content-divider"
          >
          <app-original-content
            [conversationType]="conversation!.type"
            [content]="conversation!.content ?? ''"
            [sources]="conversation!.originalSourceDetails ?? []"
            [conversationId]="conversation?.id"
            [conversationData]="conversation"
            >
          </app-original-content>
        </div>
      }
      <!-- Files display for USER messages - shown after original content -->
      @if (message.author === 'user' && ((message?.files?.length ?? 0) >= 1 || (message?.referenceFiles?.length ?? 0) >= 1)) {
        <div
          class="files-container"
          style="padding-top: 12px;"
          >
          @if ((message?.files?.length ?? 0) >= 1) {
            <div class="files-section">
              @for (file of message.files; track file) {
                <app-file-preview-modal
                  [file]="file"
                ></app-file-preview-modal>
              }
            </div>
          }
          @if ((message?.files?.length ?? 0) >= 1 && (message?.referenceFiles?.length ?? 0) >= 1) {
            <div
              class="files-separator"
            ></div>
          }
          @if ((message?.referenceFiles?.length ?? 0) >= 1) {
            <div class="files-section">
              @for (file of message.referenceFiles; track file) {
                <app-file-preview-modal
                  [file]="file"
                ></app-file-preview-modal>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  <app-slr-spinner [isLoading]="isBusy"></app-slr-spinner>
</div>

<!--    <div class="message-container">-->
<!--      &lt;!&ndash;            [isLoading]="botMessagesService.isWriting"&ndash;&gt;-->
<!--      <app-single-message-->
<!--  <ng-container *ngFor="let paragraph of msg!.paragraphs">-->
<!--    <ng-container *ngIf="paragraph.materials?.length">-->
<!--      <div class="materials-container">-->
<!--        <app-materials-preview-->
<!--          *ngFor="let mat of paragraph.materials"-->
<!--          [material]="mat"-->
<!--        ></app-materials-preview>-->
<!--      </div>-->
<!--    </ng-container>-->
<!--  </ng-container>-->

<!--  </div>-->
<!--      ></app-single-message>-->
<!--          <p *ngIf="botFinalMessage && message.author === 'assistant' && !message?.isWriting">-->
<!--            {{ botFinalMessage }}-->
<!--          </p>-->
<!--          <ng-container *ngIf="message && message.paragraphs">-->
<!--            <app-bot-quiz-answers-->
<!--              [conversationId]="conversationId"-->
<!--              [asResults]="adaptedBotConversation?.type === 'results'"-->
<!--              *ngIf="message.paragraphs[0]?.quizQuestions"-->
<!--              [message]="message"-->
<!--            ></app-bot-quiz-answers>-->
<!--          </ng-container>-->
<!--          <app-references-->
<!--            *ngIf="!['error', 'quiz'].includes(message.type)"-->
<!--            [lang]="adoptedConversation!.language"-->
<!--            [sources]="message.sources"-->
<!--          ></app-references>-->

<!--    </div>-->
<!--  </div>-->
